import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, APIEndpoints, Mutations } from "@/store/enums/StoreEnums";
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  config,
} from "vuex-module-decorators";

config.rawError = true;

@Module
export default class OverviewModule extends VuexModule {
  @Action({ rawError: true })
  [Actions.GET_OVERVIEW]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get("/attorney/" + APIEndpoints.NOTIFICATIONS)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.MARK_NOTIFICATION_AS_READ](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.NOTIFICATIONS}/${APIEndpoints.READ}`,
        payload.notificationsIds
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
